// Import api models.
import {
	BuildingLimitsPersonal,
	PerilDeductible,
} from '@app/models/api';
import ComparisonSummary, {
	ComparisonSummaryParameters,
} from './ComparisonSummary';

interface ComparisonSummaryDwellingLimitsParameters extends ComparisonSummaryParameters<BuildingLimitsPersonal> {
	oldSelectedPerilsDeductibles: PerilDeductible[];
	newSelectedPerilsDeductibles: PerilDeductible[];
}

export default class ComparisonSummaryDwellingLimits extends ComparisonSummary<BuildingLimitsPersonal> {
	public oldSelectedPerilsDeductibles: PerilDeductible[];
	public newSelectedPerilsDeductibles: PerilDeductible[];

	public constructor({
		oldSelectedPerilsDeductibles,
		newSelectedPerilsDeductibles,
		...params }: ComparisonSummaryDwellingLimitsParameters) {
		super(params);
		this.oldSelectedPerilsDeductibles = oldSelectedPerilsDeductibles;
		this.newSelectedPerilsDeductibles = newSelectedPerilsDeductibles;
	}

}